module.exports = __webpack_public_path__ + "static/img/bulk-download@2x.9873e4ae.png";